import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Spin, message } from 'antd';
import { useQuery, useMutation, gql } from '@apollo/client';

import ErrorBoundary from '../../components/Utils/ErrorBoundary';

import { PayslipDetails } from '../../components/Payroll';
import { PAYSLIP_ALL_FIELDS } from '../../apollo/fragments';
import {
  DESIGNATIONS_OPTION_QUERY,
  LOCATIONS_OPTIONS_QUERY,
  PORTFOLIO_OPTIONS_QUERY,
} from '../../apollo/queries';

import * as Config from '../../appConfig';
// import './styles.css';

var fileDownload = require('js-file-download');

const PAYSLIP_VIEW_QUERY = gql`
  ${PAYSLIP_ALL_FIELDS}
  query PayslipById($id: ID!) {
    payslipById(id: $id) {
      ...PayslipAllFields
    }
  }
`;

const PayslipView = ({ payslipId }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.login);

  const { loading, data, refetch } = useQuery(PAYSLIP_VIEW_QUERY, {
    variables: {
      id: payslipId,
    },
  });

  const onSuccessMutation = (mesageText = 'Details updated successfully!') => {
    refetch({
      variables: {
        id: payslipId,
      },
    });
    message.success(mesageText);
  };

  useEffect(() => {
    console.log('refetch payslip details');
    if (data) {
      refetch({
        variables: {
          id: payslipId,
        },
      });
    }
  }, []);

  const PayslipDetailsProps = {
    ability: user.ability,
  };

  return (
    <ErrorBoundary>
      <Spin spinning={loading}>
        {/* TODO: Below code only for force child rerender, need to find better way  */}
        {/* {payslip && !data && (
          <PayslipDetails payslip={payslip} {...PayslipDetailsProps} />
        )} */}
        {data && data.payslipById && (
          <PayslipDetails payslip={data.payslipById} {...PayslipDetailsProps} />
        )}
      </Spin>
    </ErrorBoundary>
  );
};

PayslipView.defaultProps = {};

PayslipView.propTypes = {
  payslip: PropTypes.object.isRequired,
};

export default PayslipView;
